import { Typography } from "@mui/material";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { useTranslation } from "react-i18next";
import styles from "@/components/backgroundTasks/taskCompanyList.module.css";

const VISIBLE_COMPANY_COUNT = 10;

interface Props {
  companies: string[];
}

export default function TaskCompanyList({ companies }: Props) {
  const { t } = useTranslation();
  const visibleCompanies = companies.slice(0, VISIBLE_COMPANY_COUNT);
  const hiddenCompanyCount = companies.length - visibleCompanies.length;

  return (
    <div className={styles.companiesSection}>
      <div className={styles.companiesHeading}>
        <BusinessOutlinedIcon className={styles.companiesIcon} />
        <Typography className={styles.companiesLabel}>
          {t("companies")}
        </Typography>
        <span className={styles.countBadge}>{companies.length}</span>
      </div>
      <Typography className={styles.companyList}>
        {companies.length === 0 ? "-" : visibleCompanies.join(", ")}
        {hiddenCompanyCount > 0 && (
          <span className={styles.moreCompanies}>
            {" "}
            {t("more_companies", { count: hiddenCompanyCount })}
          </span>
        )}
      </Typography>
    </div>
  );
}
